/**
 * Gumbi "Rezerviraj" (Order & Pay povezave) na single restavraciji v TR pogledu
 * (template-parts/restavracija/tr-view/content-tr.php + content-tr-sidebar.php, <a data-tr-rezervacija-link>):
 * v href dodamo izbiro iz filtra prostih terminov na naslovnici, ki jo restavracije-load.js shrani v piškotek
 * `restavracijefilter` (JSON: prosto_oseb / prosti_dan / prosta_ura). Order & Pay sprejme:
 *   prosto_oseb -> reservation_party_size     (1-6; "7plus" in "all" se ne pošljeta)
 *   prosti_dan  -> reservation_date  (YYYY-MM-DD)
 *   prosta_ura  -> reservation_time  (HH-HH, npr. 14-17)
 * Teče v brskalniku, ker so single strani v LiteSpeed page cache-u in strežnik piškotka ne vidi.
 */

const PARAMS = [
	{ cookie: 'prosto_oseb', param: 'reservation_party_size', valid: /^[1-6]$/ },
	{ cookie: 'prosti_dan', param: 'reservation_date', valid: /^\d{4}-\d{2}-\d{2}$/ },
	// { cookie: 'prosta_ura', param: 'reservation_time', valid: /^\d{1,2}-\d{1,2}$/ },
]

export function readFilterCookie(cookieString = document.cookie) {
	const match = cookieString.match(/(?:^|;\s*)restavracijefilter=([^;]+)/)
	if (!match) return null
	try {
		const parsed = JSON.parse(decodeURIComponent(match[1]))
		return parsed && typeof parsed === 'object' ? parsed : null
	} catch (e) {
		try {
			const parsed = JSON.parse(match[1])
			return parsed && typeof parsed === 'object' ? parsed : null
		} catch (e2) {
			return null
		}
	}
}

/** Vrne href z dodanimi parametri; obstoječi parametri z istim imenom se prepišejo. */
export function buildRezervacijaUrl(href, filter) {
	if (!href || !filter) return href
	let url
	try {
		url = new URL(href, window.location.href)
	} catch (e) {
		return href
	}
	let changed = false
	PARAMS.forEach(({ cookie, param, valid }) => {
		const value = filter[cookie]
		if (typeof value !== 'string' || value === '' || value === 'all' || !valid.test(value)) return
		url.searchParams.set(param, value)
		changed = true
	})
	return changed ? url.toString() : href
}

export default {
	init() {
		const links = document.querySelectorAll('a[data-tr-rezervacija-link]')
		if (!links.length) return
		const filter = readFilterCookie()
		if (!filter) return
		links.forEach((a) => {
			const href = a.getAttribute('href')
			const next = buildRezervacijaUrl(href, filter)
			if (next !== href) a.setAttribute('href', next)
		})
	},
}
